module.exports = __webpack_public_path__ + "static/img/ent-detail-68.166261f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-68.jpg
// module id = WGv+
// module chunks = 52